export default {
      id: "picto-quote-top-usage",
      viewBox: "0 0 60 49",
      url: "../dist/images/" + "sprite.svg#picto-quote-top-usage",
      toString: function () {
        return this.url;
      }
    }